import { ErrorComponent } from '@/core/components/ErrorComponent'
import { LoadingList } from '@/core/components/LoadingList'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

const quickAnswersSearchSchema = z.object({
  search: z.string().catch(''),
})

export const Route = createFileRoute('/_layout/dashboard/help-and-support/')({
  validateSearch: (search) => quickAnswersSearchSchema.parse(search),
  beforeLoad: ({ context: { auth } }) => {
    if (auth.isExpired()) {
      return
    }
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
      })
    }
  },
  pendingComponent: LoadingList,
  errorComponent: ErrorComponent,
})
